export const SelfEmploymentFlatFeeType = {
    Never: 'Never',
    MoreThanThreeYearsAgo: 'MoreThanThreeYearsAgo',
    LessThanThreeYearsAgo: 'LessThanThreeYearsAgo',
} as const

export const SocialSecurityProfileStatus = {
    Started: 'Started',
    Submitted: 'Submitted',
    Complete: 'Complete',
    Cancelled: 'Cancelled',
    InformationRequested: 'InformationRequested',
} as const

export interface SocialSecurityProfileDTO {
    userId: number
    estimatedMonthlyIncome: number | null
    hasBeenSelfEmployed: boolean | null
    hasSelectedMinimumContribution: boolean | null
    hasUploadedAuthorisationForm: boolean | null
    hasUploadedSocialSecurityNumberVerification: boolean | null
    isSocialSecurityNumberVerified: boolean | null
    mutualSocietyId: number | null
    mutualSocietyName: string | null
    selfEmploymentFlatFeeType: keyof typeof SelfEmploymentFlatFeeType | null
    status: keyof typeof SocialSecurityProfileStatus
    stoppedBeingSelfEmployedMoreThanTwoYearsAgo: boolean | null
}

export interface SocialSecurityProfileEditDTO {
    userId: number
    estimatedMonthlyIncome: number | null
    hasBeenSelfEmployed: boolean | null
    hasSelectedMinimumContribution: boolean | null
    mutualSocietyId: number | null
    selfEmploymentFlatFeeType: keyof typeof SelfEmploymentFlatFeeType | null
    status: keyof typeof SocialSecurityProfileStatus
    stoppedBeingSelfEmployedMoreThanTwoYearsAgo: boolean | null
}
